import React, { useState } from 'react';
import { Send } from 'lucide-react';

const Footer = () => {
  const [email, setEmail] = useState('');
  const [error, setError] = useState('');
  const [status, setStatus] = useState(''); // 'success' ou ''

  const validateEmail = (e) => {
    e.preventDefault();
    const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    
    if (!email) {
      setError("Veuillez entrer une adresse email.");
      setStatus('');
    } else if (!regex.test(email)) {
      setError("Format d'email invalide (ex: nom@domaine.com).");
      setStatus('');
    } else {
      setError("");
      setStatus('success');
      // Logique d'envoi ici
      console.log("Email envoyé:", email);
      setTimeout(() => setStatus(''), 3000);
    }
  };

  return (
    <footer className="bg-[#0A1931] pt-12 pb-6 px-6 border-t border-white/5">
      <div className="max-w-7xl mx-auto">
        
        {/* Grille Principale */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mb-10">
          
          {/* Section 1: Branding */}
          <div className="space-y-4">
            <h2 className="text-2xl font-black text-white tracking-tight">Nodixs</h2>
            <p className="text-gray-400 text-sm leading-relaxed max-w-[240px]">
              Votre partenaire de confiance pour la cybersécurité offensive et la protection des données stratégiques.
            </p>
          </div>

          {/* Section 2: Expertise */}
          <div>
            <h4 className="text-white font-bold mb-5 text-sm uppercase tracking-wider">Expertise</h4>
            <ul className="text-gray-400 space-y-2.5 text-sm">
              <li className="hover:text-blue-400 transition-colors cursor-pointer">Audit OSINT Entreprise</li>
              <li className="hover:text-blue-400 transition-colors cursor-pointer">Pentest Web</li>
              <li className="hover:text-blue-400 transition-colors cursor-pointer">Audit Infrastructure</li>
              <li className="hover:text-blue-400 transition-colors cursor-pointer">Réponse aux incidents</li>
            </ul>
          </div>

          {/* Section 3: Newsletter Personnalisée */}
          <div>
            <h4 className="text-white font-bold mb-5 text-sm uppercase tracking-wider">Restez à jour</h4>
            <p className="text-gray-400 mb-4 text-sm">Abonnez-vous à notre veille cyber mensuelle.</p>
            
            <form onSubmit={validateEmail} className="relative max-w-[280px]">
              <div className={`flex rounded-lg overflow-hidden transition-all duration-300 ${error ? 'ring-2 ring-red-500' : 'ring-1 ring-white/10'}`}>
                <input 
                  type="text" 
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="votre@email.com" 
                  className="bg-[#F1F5F9] px-3 py-2 w-full text-xs text-[#0A1931] outline-none placeholder:text-gray-400" 
                />
                <button 
                  type="submit"
                  className="bg-[#3b82f6] hover:bg-blue-600 transition-colors text-white px-4 py-2 flex items-center justify-center"
                >
                  <Send size={14} fill="currentColor" />
                </button>
              </div>

              {/* Messages d'erreur ou succès sous l'input */}
              {error && (
                <p className="absolute left-0 mt-1 text-[10px] text-red-400 font-medium animate-in fade-in slide-in-from-top-1">
                  {error}
                </p>
              )}
              {status === 'success' && (
                <p className="absolute left-0 mt-1 text-[10px] text-green-400 font-medium">
                  Inscription réussie !
                </p>
              )}
            </form>
          </div>

          {/* Section 4: Nodixs Liens */}
          <div className="lg:pl-8">
            <h4 className="text-white font-bold mb-5 text-sm uppercase tracking-wider">Nodixs</h4>
            <ul className="text-gray-400 space-y-2.5 text-sm">
              <li className="hover:text-white transition-colors cursor-pointer">Accueil</li>
              <li className="hover:text-white transition-colors cursor-pointer">Services OSINT</li>
              <li className="hover:text-white transition-colors cursor-pointer">Services Pentest</li>
              <li className="hover:text-white transition-colors cursor-pointer">Prise de rendez-vous</li>
              <li className="hover:text-white transition-colors cursor-pointer">Ressources</li>
              <li className="hover:text-white transition-colors cursor-pointer">Contact</li>
            </ul>
          </div>
        </div>

        <div className="h-[1px] bg-white/10 w-full mb-6"></div>

        <div className="flex flex-col md:flex-row justify-between items-center gap-4 text-[11px] text-gray-500 font-medium uppercase tracking-widest">
          <p>© 2024 Nodixs. Tous droits réservés.</p>
          <div className="flex gap-6">
            <a href="#" className="hover:text-white transition-colors">Mentions Légales</a>
            <a href="#" className="hover:text-white transition-colors">Confidentialité</a>
            <a href="#" className="hover:text-white transition-colors">Cookies</a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;